import { PaymentSummary, SaleTransaction, Transaction } from './transactionTypes';
import { processSaleTransaction } from './salesProcessor';
import { processCreditPayments } from './creditProcessor';
import { processReturnTransaction } from './returnsProcessor';

export const processSalesAndPayments = (
  data: any,
  summariesMap: Map<string, PaymentSummary>,
  creditSummary: PaymentSummary
) => {
  data.sales?.forEach((transaction: SaleTransaction) => {
    // Process all sales transactions
    processSaleTransaction(transaction, summariesMap);
    
    // Process credit payments
    processCreditPayments(transaction, summariesMap);
  });

  // Sort transactions by date
  summariesMap.forEach(summary => {
    if (summary.transactions) {
      summary.transactions.sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    }
  });
};

export const processReturns = (
  data: any,
  summariesMap: Map<string, PaymentSummary>
) => {
  data.returns?.forEach((returnTx: any) => {
    if (returnTx.refund_amount && returnTx.refund_payment_method) {
      processReturnTransaction(returnTx, summariesMap);
    }
  });
};